import * as React from "react";
import { useLocation } from "react-router-dom";
import { WINDOW_QUERY } from "../themeV2/windowSizeClass";
import useMediaQuery from "./useMediaQuery";

export default function useShrinkBuffer() {
  const location = useLocation();
  const isExpanded = useMediaQuery(WINDOW_QUERY.expanded);

  const isDashboard = React.useMemo(() => {
    const path = location.pathname.toLowerCase();
    return path.startsWith("/dashboard");
  }, [location.pathname]);

  const showMobileNav = isDashboard && !isExpanded;

  return React.useMemo(
    () => ({ isDashboard, showMobileNav }),
    [isDashboard, showMobileNav],
  );
}
